module.exports = __webpack_public_path__ + "img/pringels.2837f92e.png";